import { render } from "./FlirtNewChat.vue?vue&type=template&id=6fea34a7&scoped=true&ts=true"
import script from "./FlirtNewChat.vue?vue&type=script&lang=ts"
export * from "./FlirtNewChat.vue?vue&type=script&lang=ts"

import "./FlirtNewChat.vue?vue&type=style&index=0&id=6fea34a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fea34a7"]])

export default __exports__